import React, {useMemo} from "react";

import {Avatar, InitAvatarAction} from "../../../schema";

import AvatarIcon from "../../AvatarIcon";
import SessionActionDisplay from "./SessionActionDisplay";
import {getTextWithStressMarks} from "../../Phrase";

type props = React.ComponentProps<"div"> & {
  initAvatarAction: InitAvatarAction;
  avatar: Avatar;
};

const InitAvatarActionDisplay = function ({initAvatarAction, avatar, ...props}: props) {
  const text = useMemo(() => getTextWithStressMarks(initAvatarAction.text), [initAvatarAction.text]);

  return (
    <SessionActionDisplay variant="avatar" icon={<AvatarIcon adaptive avatar={avatar} />} {...props}>
      {text}
    </SessionActionDisplay>
  );
};

export default InitAvatarActionDisplay;
